export default __webpack_public_path__ + "static/blog-9f901d6cce54f53c804b12603fbe5988.jpg";